import React from "react";
import "./mbti.scss";
import INTJ from "./INTJ";
import INTP from "./INTP";
import ENTJ from "./ENTJ";
import ENTP from "./ENTP";
import INFJ from "./INFJ";
import INFP from "./INFP";
import ENFJ from "./ENFJ";
import ENFP from "./ENFP";
import ISTJ from "./ISTJ";
import ISFJ from "./ISFJ";
import ESTJ from "./ESTJ";
import ESFJ from "./ESFJ";

import ISFP from "./ISFP";
import ISTP from "./ISTP";
import ESTP from "./ESTP";
import ESFP from "./ESFP";

export default function MbtiComponents(props) {
  const Components = {
    ISTJ,
    INTJ,
    INTP,
    ENTJ,
    ENTP,
    INFJ,
    INFP,
    ENFJ,
    ENFP,
    ISFJ,
    ESTJ,
    ESFJ,
    ISFP,
    ISTP,
    ESTP,
    ESFP,
  };
  const Component = Components[props.name.toUpperCase()];
  return <Component />;
}
